import React from "react";
import styled from "styled-components";
import Modal from "react-modal";
import Button from "../Buttons";
import { Colors } from "../../ColorConstants";

const PromoModal = ({
  onClosePromoModal,
  isPromoOpen,
  promo,
  savings,
  promotionMsg,
}) => {
  return (
    <Modal
      isOpen={isPromoOpen}
      onRequestClose={onClosePromoModal}
      contentLabel="Modal confirmation"
      style={{
        content: {
          height: "auto",
          width: "auto",
          display: "grid",
          justifyContent: "center",
          padding: 0,
          background: "transparent",
          border: "none",
          position: "unset",
          borderRadius: 0,
        },
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
      }}
    >
      <PromoModalContainer>
        <PromoImg src={require("../../assets/icons/promo.png")} />
        <PromoDetailsContainer>
          <PromoCode>`{promo}`</PromoCode>
          <Savings>{savings} savings with this promocode</Savings>
          <PromoCode style={{ color: "black" }}>{promotionMsg}</PromoCode>
          <Button
            label="Yay!"
            backgroundColor={Colors.aqua}
            variant="filled"
            onClick={onClosePromoModal}
          />
        </PromoDetailsContainer>
      </PromoModalContainer>
    </Modal>
  );
};

const PromoImg = styled.img`
  width: 6rem;
  position: relative;
  top: 2.5rem;
`;

const PromoCode = styled.div`
  padding-top: 1rem;
  font-size: 1.1rem;
  color: ${Colors.grey};
  padding-bottom: 1.5rem;
`;
const Savings = styled.div`
  font-size: 1.8rem;
  font-weight: 700;
  color: ${Colors.aqua};
`;
const PromoDetailsContainer = styled.div`
  padding: 2rem;
  background: white;
  padding-top: 3rem;
  width: 100%;
  border-radius: 1rem;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  flex-direction: column;
`;

const PromoModalContainer = styled.div`
  min-width: 15rem;
  max-width: 25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default PromoModal;
